import { useEffect, useState } from "react";

const WA_NUMBER = "919820168800"; // +91 98201 68800, digits only
const WA_MESSAGE = "Hi Terrazzo India, I'd like to enquire about your products.";

export default function WhatsAppButton() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 600);
    return () => clearTimeout(t);
  }, []);

  const href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGE)}`;

  return (
    <a
      data-testid="whatsapp-button"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Terrazzo India on WhatsApp"
      className={`fixed bottom-16 right-4 sm:bottom-20 sm:right-5 md:bottom-7 md:right-7 z-[60] group transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
      }`}
    >
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full animate-ping" style={{background: "rgba(37,211,102,0.35)"}} />

      {/* Button body */}
      <span
        className="relative flex items-center gap-2 pl-3 pr-1 py-1 rounded-full shadow-lg border border-white/20 backdrop-blur"
        style={{ background: "#25D366" }}
      >
        <span className="hidden md:inline-block font-mono-label text-white pr-2 pl-1 text-[0.65rem] tracking-widest opacity-0 group-hover:opacity-100 max-w-0 group-hover:max-w-[200px] overflow-hidden whitespace-nowrap transition-all duration-500">
          Chat on WhatsApp
        </span>
        <span
          className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full transition-transform group-hover:scale-105"
          style={{ background: "#25D366" }}
        >
          {/* WhatsApp glyph */}
          <svg viewBox="0 0 24 24" className="w-7 h-7 md:w-8 md:h-8" fill="#ffffff" aria-hidden="true">
            <path d="M19.11 4.91A10.05 10.05 0 0 0 12.02 2C6.5 2 2.04 6.46 2.04 11.98c0 2.11.55 4.16 1.6 5.98L2 22l4.18-1.6a9.95 9.95 0 0 0 5.84 1.88h.01c5.52 0 9.98-4.46 9.98-9.98a9.9 9.9 0 0 0-2.9-7.39ZM12.03 20.5h-.01a8.27 8.27 0 0 1-4.22-1.16l-.3-.18-2.48.95.95-2.42-.2-.31a8.27 8.27 0 0 1-1.27-4.4c0-4.58 3.73-8.31 8.32-8.31a8.26 8.26 0 0 1 5.88 2.44 8.27 8.27 0 0 1 2.43 5.88c0 4.58-3.72 8.5-8.31 8.5h-.01Zm4.55-6.21c-.25-.13-1.47-.73-1.7-.81-.23-.08-.4-.13-.56.13-.17.25-.65.81-.79.97-.15.17-.3.19-.55.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.38-1.73-.14-.25-.02-.39.11-.51.11-.11.25-.3.38-.45.13-.15.17-.25.25-.42.08-.17.04-.31-.02-.44-.06-.13-.56-1.34-.77-1.84-.2-.49-.41-.42-.56-.43h-.48a.93.93 0 0 0-.67.31c-.23.25-.88.86-.88 2.1 0 1.24.9 2.43 1.03 2.6.13.17 1.78 2.73 4.32 3.82.6.26 1.08.42 1.45.54.61.19 1.16.17 1.6.1.49-.07 1.47-.6 1.67-1.18.2-.58.2-1.08.14-1.18-.07-.1-.23-.16-.48-.29Z"/>
          </svg>
        </span>
      </span>
    </a>
  );
}
